module.exports = __webpack_public_path__ + "img/lineup-2.97df514d.jpg";